import type { FunctionComponent } from 'react';

/**
 * ListRowSubtitle is the "subtitle" or secondary piece of text
 * in a given list row.
 */
const ListRowSubtitle: FunctionComponent = ({ children }) => (
  <div className="fossa-list__row__subtitle">
    {children}
  </div>
);

export default ListRowSubtitle;
